import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.5);
  `;
Wrapper.displayName = 'Wrapper';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  padding: 27px 33px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.24);
  border-radius: 2px;
  border-top: 10px solid ${colors.softBlue};
  background-color: ${({ theme }) => theme.backgrounds.editModal};
`;
ModalContent.displayName = 'ModalContent';

export const EditorWrapper = styled.div`
  flex: 1 1 0px;
  margin-top: ${({ isBulk }) => isBulk ? '14px' : '0'};
`;
EditorWrapper.displayName = 'EditorWrapper';

export const BulkDescription = styled.p`
  font-size: 12.5px;
  color: ${colors.grey19};
`;
BulkDescription.displayName = 'BulkDescription';

export const Title = styled.h5`
  color: ${({ theme }) => theme.text.customAttributeBulkEdit};
  font-weight: 600;
  font-size: 17.5px;
  margin-bottom: 13px;
`;
Title.displayName = 'Title';

export const ChoiceWrapper = styled.div`
  height: 130px;
  background-color: ${({ theme }) => theme.backgrounds.editModalContent};
  padding: 13px 0 9px 20px;
`;
ChoiceWrapper.displayName = 'ChoiceWrapper';

export const DateWrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.backgrounds.editModalContent};
  height: 130px;
`;
DateWrapper.displayName = 'DateWrapper';

export const DateBox = styled.div`
  width: 100%;
  height: 49px;
  margin: 9px 0 11px;
  padding: 16px 8px 5px 20px;
  background-color:${({ theme }) => theme.backgrounds.dateCustomAttribute};
  font-size: 12.5px;
  color: ${({ isEmpty, theme }) => isEmpty ? colors.blueGrey : theme.text.dateInput};
  cursor: pointer;
`;
DateBox.displayName = 'DateBox';

export const InputWrapper = styled.div`
  position: absolute;
  top: 52px;
  left: 20px;
`;
InputWrapper.displayName = 'InputWrapper';

export const DateFieldName = styled(Title)`
  padding: 11px 20px 0 20px;
  margin: 0;
`;
DateFieldName.displayName = 'DateFieldName';
